var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50085 6.37494H3.75085C3.35303 6.37494 2.9715 6.53297 2.69019 6.81428C2.40889 7.09558 2.25085 7.47711 2.25085 7.87494C2.25085 8.27276 2.40889 8.65429 2.69019 8.9356C2.9715 9.2169 3.35303 9.37494 3.75085 9.37494H4.50085H15.7509M8.25085 15.3749H7.12585C6.72803 15.3749 6.3465 15.2169 6.06519 14.9356C5.78389 14.6543 5.62585 14.2728 5.62585 13.8749C5.62585 13.4771 5.78389 13.0956 6.06519 12.8143C6.3465 12.533 6.72803 12.3749 7.12585 12.3749H8.25085H12.7509M15.0009 5.62494H9.00085C8.60303 5.62494 8.2215 5.4669 7.94019 5.1856C7.65889 4.90429 7.50085 4.52276 7.50085 4.12494C7.50085 3.72711 7.65889 3.34558 7.94019 3.06428C8.2215 2.78297 8.60303 2.62494 9.00085 2.62494H10.1259M9.00085 5.62494H10.1259",
    stroke: "#18202F",
    strokeWidth: 1.49999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathwork);
export default __webpack_public_path__ + "static/media/breathwork.70c4f707ae5b828604ac83d3fb7094d6.svg";
export { ForwardRef as ReactComponent };